import { Icon } from "@iconify/react/dist/iconify.js";
import { motion } from "framer-motion";

/**
 * Banner superior del summary de Fortalezas 2.0.
 * Reutiliza los estilos cs-* para consistencia con los otros resúmenes.
 */
const PtHeader = ({ totalRespuestas, totalSi, totalFortalezas }) => {
  return (
    <motion.div
      className="card radius-12 mb-20 cs-header-card"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="card-body p-20 text-center">
        <motion.div
          className="cs-success-icon-wrap"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            delay: 0.2,
            type: "spring",
            stiffness: 200,
            damping: 14,
          }}
        >
          <div className="cs-success-ring" />
          <div className="cs-success-icon">
            <Icon icon="mdi:trophy-award" />
          </div>
        </motion.div>

        <motion.h2
          className="text-xl fw-bold text-primary-600 mb-8 cs-header-title"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.4 }}
        >
          ¡Fortalezas completadas!
        </motion.h2>

        <motion.p
          className="text-md mb-0 cs-header-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.4 }}
        >
          Respondiste <strong>{totalSi}</strong> de{" "}
          <strong>{totalRespuestas}</strong> afirmaciones con "Sí" a lo largo
          de <strong>{totalFortalezas}</strong>{" "}
          {totalFortalezas === 1 ? "fortaleza" : "fortalezas"}
        </motion.p>

        <motion.div
          className="cs-talent-dots"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.4 }}
        >
          {Array.from({ length: Math.min(totalFortalezas, 7) }, (_, i) => (
            <motion.div
              key={i}
              className="cs-talent-dot"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                delay: 0.65 + i * 0.07,
                type: "spring",
                stiffness: 260,
                damping: 16,
              }}
            />
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default PtHeader;
